import { Item } from "@/modules/location";
import { OOCCategoryType } from "@/types/app/ooc/menus.type";
import { OOCCategoryInterface } from "@/interface/app/ooc/menu.interface";

export default class Category implements OOCCategoryInterface {
  name: string = "";
  external_id: string = "";
  id: string = "";
  items_count: number = 0;
  local_name: string = "";
  order: string = "";
  isStaged: boolean = false;
  items: Array<any> = [];
  constructor(data: OOCCategoryType) {
    if (data.items_count < 0) {
      return;
    }
    if (data) {
      this.id = data.id;
      this.items_count = data.items_count;
      this.name = data.name;
      this.local_name = data.local_name;
      this.order = data.order;
      this.isStaged = data.isStaged || false;
      this.items = [];
      this.prepareItems(data);
    }
  }

  /**
   * checks if the category exists in the menu categories
   * @param stagedCategories
   */
  public checkIsStaged(stagedCategories): boolean {
    return stagedCategories?.find((category) => category.id === this.id);
  }

  /**
   * will remove/add the item depending if it is used or not
   * @param item
   */
  public handlingTogglingItem(item) {
    item?.checkIsStaged(this.items) ? this.removeItem(item) : this.addItem(item);
  }

  /**
   * remove item
   * @param chosenItem
   * @private
   */
  private removeItem(chosenItem) {
    this.items.splice(
      this.items.findIndex((item) => item.name === chosenItem.name),
      1
    );
  }

  /**
   * add item
   * @param item
   * @private
   */
  private addItem(item) {
    this.items.push(item);
  }

  /**
   * replace items from menu that can be already edited with items coming from catalog
   * @param catalogItems
   */
  private replaceMenuItemWithOriginalItem(catalogItems): Array<any> {
    return catalogItems?.map((obj) => this.items?.find((item) => item.id === obj.id) || obj);
  }

  /**
   * displays the correct items for the chosen category
   */
  private catalogItemsForThisCategory(catalogItems): Array<any> {
    return catalogItems?.filter((item) => item.category_id === this.id);
  }

  /**
   * prepare the correct items to display in the items table
   * @param catalogItems
   */
  public prepareCatalogItems(catalogItems): Array<Item> {
    return this.replaceMenuItemWithOriginalItem(this.catalogItemsForThisCategory(catalogItems));
  }

  /**
   * check if catalog items are already fetched for this category
   * @param catalogItems
   */
  public isAlreadyFetched(catalogItems): number {
    return catalogItems?.filter((catalog) => catalog["category_id"] === this.id).length;
  }

  /**
   * get items count of original items
   * @param catalog
   * @return {number}
   */
  public getItemCountOfOriginal(catalog): number {
    let original = catalog.filter((item) => item.id === this.id);
    if (original.length) {
      return original[0]?.items_count;
    }
    return 0;
  }

  /**
   *
   * @param data
   * @private
   */
  private prepareItems(data) {
    this.items = data.items?.map((item) => new Item(item).prepareOocItem()) || [];
  }
}
